import React, { useState, useEffect } from 'react';
import styles from './menuHome.module.scss';
import { TabBar } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import  { ApiCore } from '../../api/index';
import ProjectBreif from '../projectBrief/projectBrief';
import ExcellentCase from '../excellentCase/excellentCase';
import CaseUpload from '../caseUpload/caseUpload';
import utils from '../../utils/utils';
import Menus from './menu.json';
//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3398857_mcvnz8cwfxq.js'
});


const api = new ApiCore();

const existIcon = {
    'projectBrief': <ProjectBreif />,
    'excellentCase': <ExcellentCase />,
    'caseUpload': <CaseUpload />
}

class MenuHome extends React.Component<any, any> {

    constructor(props: any) {
      super(props);
      this.state = {
        selectedTab: 'projectBrief',
        hideMenu: false,
        menuArr: []
      };
    }

    componentDidMount() {
        const urlParams = utils.getUrlParams();
        const tab = urlParams && urlParams.tab;
        let _urlHideMenu = urlParams.hideMenu;
        if (_urlHideMenu !== undefined) {
            this.setState({
                hideMenu: _urlHideMenu == '1'
            });
        }
        if (tab) {
            this.setState({
                selectedTab: tab
            }, () => {
                this.getMenus();
            });
        } else {
            this.getMenus();
        }
    }

    getMenus() {
        const _data = Menus.data[0].children;
        this.setState({
            menuArr: _data
        })
        if (_data) {
            let selectedTab = this.state.selectedTab;
            (_data || []).some(val => {
                if (val.icon === selectedTab) {
                    document.title = val.name;
                    return true;
                }
            })
        }
    }

    menusRender() {
        const menuArr = this.state.menuArr;
        if (!menuArr || (menuArr && menuArr.length === 0)) {
            return null;
        }
        return (
        <TabBar
            unselectedTintColor="#989898"
            tintColor="#8A7AFB"
            barTintColor="white"
            hidden={this.state.hideMenu}
        >
            {menuArr.map((item: any) => {
                let iconView = item.icon;
                let IconComponent: any = '';
                if (existIcon[item.icon]) {
                    IconComponent = existIcon[item.icon];
                } else {
                    IconComponent = item.icon;
                }
                if (this.state.selectedTab != item.icon) {
                    IconComponent = null;
                }
                return (
                    <TabBar.Item
                        icon={<IconFont type={`icon-${iconView}`} className={`tabbar-icon-${iconView}`}></IconFont>}
                        selectedIcon={<IconFont type={`icon-active-${iconView}`} className={`tabbar-icon-active-${iconView} tabbar-icon-${iconView}`}></IconFont>}
                        title={<div style={{color: this.state.selectedTab == item.icon ? '#41b979' : '', fontSize: '13px'}}>{item.name}</div>}
                        key={item.icon}
                        selected={this.state.selectedTab === item.icon}
                        onPress={() => {
                            this.setState({
                                selectedTab: item.icon
                            },() => {
                                window.history.replaceState({}, item.name, `#/medicalLive?tab=` + item.icon );
                            });
                            setTimeout(() => { document.title = item.name; }, 0);
                        }}
                    >
                        {
                            this.state.selectedTab == item.icon ? IconComponent : null
                        }
                    </TabBar.Item>
                )
            })}
        </TabBar>
        )
    }

    render() {
        return (
            <div className={`${styles.homeMenu_content} ${this.state.hideMenu ? styles.hide_menu_btn : ''}`}>
                {
                    this.menusRender()
                }
            </div >
        )
    };
}
export default MenuHome;